export const allQueryTypes = [
  {
    id: 1,
    shortcode: "SVQ",
    name: "SVQ - 28",
    tenCode: "28/",
  },
  {
    id: 2,
    shortcode: "SNQ",
    name: "SNQ - 27 Name/DOB",
    tenCode: "27/",
  },
  {
    id: 3,
    shortcode: "RQ",
    name: "RQ - VIN",
    tenCode: "28/",
  },
  {
    id: 4,
    shortcode: "QVP",
    name: "QVP - Registered 28 by PID",
    tenCode: "28/",
  },
  {
    id: 5,
    shortcode: "QDL",
    name: "QDL - 27 VT PID",
    tenCode: "27/",
  },
  {
    id: 6,
    shortcode: "DQ",
    name: "DQ - 27 OOS PID",
    tenCode: "27/",
  },
  {
    id: 7,
    shortcode: "QNM",
    name: "QNM - 27 Name/DOB Soundex",
    tenCode: "27/",
  },
  {
    id: 8,
    shortcode: "XQ",
    name: "XQ - 28 Canadian",
    tenCode: "28/",
  },
  {
    id: 9,
    shortcode: "UQ",
    name: "UQ - 27 Canadian",
    tenCode: "27/",
  },
  {
    id: 10,
    shortcode: "KQ",
    name: "KQ - 27 Driver History",
    tenCode: "27/",
  },
  {
    id: 11,
    shortcode: "SQ",
    name: "SQ - 28 Snowmobile",
    tenCode: "28/",
  },
  {
    id: 12,
    shortcode: "BQ",
    name: "BQ - 28 Boat",
    tenCode: "28/",
  },
];

export const vehicleQueryTypes = allQueryTypes.filter(
  query =>
    query.shortcode === "SVQ" ||
    query.shortcode === "RQ" ||
    query.shortcode === "XQ"
);
